import PropTypes from 'prop-types';
import { Box, Card, CardContent } from '@mui/material';
import React, { forwardRef } from 'react';
import AppText from 'components/widgets/AppText';

const AppCardView = forwardRef(
    (
        { 
            header, 
            icon, 
            title, 
            titleProps = {variant: "h6", gutterBottom: true}, 
            description, 
            descriptionProps = {color: "text.secondary"}, 
            footer, 
            iconScale = 1.5, 
            sx = {} 
        },
        ref
    ) => {
        return (
            <Card
                ref={ref}
                sx={{
                    boxShadow: 3,
                    transition: 'transform 0.3s, box-shadow 0.3s',
                    '&:hover': {
                        transform: 'scale(1.05)',
                        boxShadow: 6,
                    },
                    ...sx
                }}>

                <CardContent sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    py: 4,
                    px: 2
                }}>
                    { header }
                    {icon && (
                        <Box color="primary.main" mb={2} sx={{ transform: `scale(${iconScale})` }}>
                            {icon}
                        </Box>
                    )}
                    {title && (
                        <AppText text = {title} {...titleProps} />
                    )}
                    {description && (
                        <AppText text = {description} {...descriptionProps} />
                    )}
                    { footer }
                </CardContent>
            </Card>
        );
    }
);

AppCardView.propTypes = {
    icon: PropTypes.node,
    title: PropTypes.string,
    description: PropTypes.string,
    iconScale: PropTypes.number,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sx: PropTypes.object,
};

export default AppCardView;
